import script from "./PaperDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperDetail.vue?vue&type=script&setup=true&lang=js"

import "./PaperDetail.vue?vue&type=style&index=0&id=dbd43004&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbd43004"]])

export default __exports__